<template lang="pug">
div.events--comments-form
  .events--comments-error(v-if="errorMessage")
    | {{ errorMessage }}
  .events--comments-form-field(v-if="canComment")
    .events--comments-form-field-input
      textarea.form-control(
        v-model="comment.body"
        rows="1"
        placeholder="コメントを入力"
        v-on:keyup.enter.ctrl.exact="onSubmit"
      )
    .events--comments-form-field-submit
      button.btn.btn-primary(
        @click="onSubmit"
        :disabled="isSubmitDisabled"
      )
        i.fa.fa-paper-plane.font-awesome-icon
        span 投稿する
  .events--comments-form-invalid(v-else)
    | コメントは参加者および気になる！登録した方にご利用いただけます。

</template>

<script>
export default {
  props: {
    errorMessage: {
      type: String,
      default: null
    },
    canComment: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      comment: {
        body: ''
      }
    };
  },
  computed: {
    isSubmitDisabled: function() {
      return !this.comment.body.replace(/\r?\n/g, '').trim();
    }
  },
  methods: {
    onSubmit: function() {
      if (this.isSubmitDisabled) {
        return;
      }
      this.$emit('submit-comment-form', {
        event_comment: { body: this.comment.body }
      });
      this.comment.body = '';
    }
  }
};
</script>
